import { QueryClient } from '@tanstack/vue-query'
import { Ref, ref } from 'vue'
import SubcontractorService from '@/services/SubcontractorService'
import { Subcontractor } from '@/models/subcontractor'

export default function useGetAllSubs() {
  const queryClient = new QueryClient()
  const data: Ref<Subcontractor[]> = ref(null)
  const error = ref(null)
  const subcontractorService = new SubcontractorService()

  queryClient.fetchQuery({
    queryKey: ['subcontractors'],
    queryFn: async () => {
      const data = await subcontractorService.all()
      
      // create a detail cache for each item
      data.forEach((item) => {
        queryClient.setQueryData(['subcontractor', item.id], item)
      })

      return data
    }
  }).then((response) => {
    data.value = response
  }).catch((err) => { 
    error.value = err
  })

  return { data, error }
}